export const GridConfig = {
    gridMode: 'form', // form - popup - row - batch
    showFilterRow: true,
    currentFilter: true,
    showHeaderFilter: true,
    columnChooser: true,
    groupPanel: true,
    searchPanel: true,
    exportGrid: true
};

export const Mascaras = {
    Cpf: '000.000.000-00',
    Cnpj: '00.000.000/0000-00',
    Cep: '00000-000'
};

export function calculaAlturaGrid () {
    return window.innerHeight / 1.5;
}

export function adicionaIconesGrid (e) {
    if (e.rowType === 'data' && e.column.command === 'edit') {
        const isEditing = e.row.isEditing;
        const cellElement = e.cellElement;

        if (GridConfig.gridMode === 'batch') {
            const deleteLink = cellElement.querySelector('.dx-link-delete');
            const undeleteLink = cellElement.querySelector('.dx-link-undelete');

            if (deleteLink !== null) {
                deleteLink.classList.add('dx-icon-trash');
                deleteLink.textContent = '';
            }
            if (undeleteLink !== null) {
                undeleteLink.classList.add('dx-icon-revert');
                undeleteLink.textContent = '';
            }
        } else {
            if (isEditing) {
                const saveLink = cellElement.querySelector('.dx-link-save');
                const cancelLink = cellElement.querySelector('.dx-link-cancel');

                saveLink.classList.add('dx-icon-save');
                cancelLink.classList.add('dx-icon-revert');

                saveLink.textContent = '';
                cancelLink.textContent = '';
            } else {
                const editLink = cellElement.querySelector('.dx-link-edit');
                const deleteLink = cellElement.querySelector('.dx-link-delete');

                editLink.classList.add('dx-icon-edit');
                deleteLink.classList.add('dx-icon-trash');

                editLink.textContent = '';
                deleteLink.textContent = '';
            }
        }
    }
}

export function formataCPF (cellInfo) {
    let str = cellInfo.valueText + '';

    if (str.length <= 11) {
      // Remove tudo o que não é dígito
      str = str.replace(/\D/g, '');
      // Coloca um ponto entre o terceiro e o quarto dígitos
      str = str.replace(/(\d{3})(\d)/, '$1.$2');
      // Coloca um ponto entre o terceiro e o quarto dígitos para o segundo bloco
      str = str.replace(/(\d{3})(\d)/, '$1.$2');
      // Coloca um hífen entre o terceiro e o quarto dígitos
      str = str.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    }

    return str;
}

export function formataCNPJ (cellInfo) {
    let str = cellInfo.valueText + '';

    // Remove tudo o que não é dígito
    str = str.replace(/\D/g, '');
    // Coloca ponto entre o segundo e o terceiro dígitos
    str = str.replace(/^(\d{2})(\d)/, '$1.$2');
    // Coloca ponto entre o quinto e o sexto dígitos
    str = str.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
    // Coloca uma barra entre o oitavo e o nono dígitos
    str = str.replace(/\.(\d{3})(\d)/, '.$1/$2');
    // Coloca um hífen depois do bloco de quatro dígitos
    str = str.replace(/(\d{4})(\d)/, '$1-$2');

    return str;
}

export function formataCEP (cellInfo) {
    const str = cellInfo.valueText + '';
/*
    let str = cellInfo.valueText + '';
    // Remove tudo o que não é dígito
    str = str.replace(/\D/g, '');
    // Coloca um hífen depois do bloco de quatro dígitos
    str = str.replace(/(\d{5})(\d)/, '$1-$2');
*/

    return formataCEPTxt(str);
}

export function formataCEPTxt (str) {

    // Remove tudo o que não é dígito
    str = str.replace(/\D/g, '');
    // Coloca um hífen depois do bloco de quatro dígitos
    str = str.replace(/(\d{5})(\d)/, '$1-$2');

    return str;
}

export function formataCurrency (cellInfo) {

  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  });

  // pega o valor no campo e transforma em float
  const valor = parseFloat(cellInfo.value);
  /* formata conforme configurações definidas no formatter */
  if (valor > 0) {
    return formatter.format(valor);
  } else {
      return 0;
  }
}

export function formataDataHora(date) {
    const year = date.getFullYear(),
            month = date.getMonth() + 1, // months are zero indexed
            day = date.getDate(),
            hour = date.getHours(),
            minute = date.getMinutes(),
            second = date.getSeconds(),
            time = date.toTimeString();

    //return day + '/' + month + '/' + year + ' ' + hour + ':' + minute;
    return ('00' + day).slice(-2) + '/' + ('00' + month).slice(-2) + '/' + year + ' - ' +
           ('00' + hour).slice(-2) + ':' + ('00' + minute).slice(-2);
}

export const messagesLocale = {
    en: {
        Yes: 'Sim',
        No: 'Não',
        Cancel: 'Cancelar',
        Clear: 'Limpar',
        Done: 'Ok',
        Loading: 'Carregando...',
        Select: 'Selecione...',
        Search: 'Pesquisar',
        Back: 'Voltar',
        OK: 'OK',
        'dxCollectionWidget-noDataText': 'Sem registros.', // No data to display
        'validation-required': 'Obrigatório', // Required
        'validation-required-formatted': '{0} é obrigatório', // {0} is required
        'validation-numeric': 'Valor precisa ser um número', // Value must be a number
        'validation-numeric-formatted': '{0} precisa ser um número', // {0} must be a number
        'validation-range': 'Valor está fora do alcance', // Value is out of range
        'validation-range-formatted': '{0} está fora do alcance', // {0} is out of range
        'validation-stringLength': 'O tamanho do valor é incorreto', // The length of the value is not correct
        'validation-stringLength-formatted': 'O tamanho do {0} é incorreto', // The length of {0} is not correct
        'validation-custom': 'Valor é inválido', // Value is invalid
        'validation-custom-formatted': '{0} é inválido', // {0} is invalid
        'validation-compare': 'Valor não combina', // Values do not match
        'validation-compare-formatted': '{0} não combina', // {0} does not match
        'validation-pattern': 'Valor não combina com o padrão', // Value does not match pattern
        'validation-pattern-formatted': '{0} não combina com o padrão', // {0} does not match pattern
        'validation-email': 'E-mail é inválido', // Email is invalid
        'validation-email-formatted': '{0} é inválido', // {0} is invalid
        'validation-mask': 'Valor é inválido', // Value is invalid
        'dxLookup-searchPlaceholder': 'Número mínimo de caracteres: {0}', // Minimum character number: {0}
        'dxList-pullingDownText': 'Puxe para baixo para recarregar', // Pull down to refresh...
        'dxList-pulledDownText': 'Solte para recarregar', // Release to refresh...
        'dxList-refreshingText': 'Recarregando...', // Refreshing...
        'dxList-pageLoadingText': 'Carregando...', // Loading...
        'dxList-nextButtonText': 'Mais', // More
        'dxList-selectAll': 'Selecione Todos', // Select All
        'dxListEditDecorator-delete': 'Excluir', // Delete
        'dxListEditDecorator-more': 'Mais', // More
        'dxScrollView-pullingDownText': 'Puxe para baixo para recarregar', // Pull down to refresh...
        'dxScrollView-pulledDownText': 'Solte para recarregar', // Release to refresh...
        'dxScrollView-refreshingText': 'Recarregando...', // Refreshing...
        'dxScrollView-reachBottomText': 'Carregando...', // Loading...
        'dxDateBox-simulatedDataPickerTitleTime': 'Selecione uma hora', // Select time
        'dxDateBox-simulatedDataPickerTitleDate': 'Selecione uma data', // Select date
        'dxDateBox-simulatedDataPickerTitleDateTime': 'Selecione uma data e hora', // Select date and time
        'dxDateBox-validation-datetime': 'O valor precisa ser uma data ou hora', // Value must be a date or time
        'dxFileUploader-selectFile': 'Selecione um arquivo', // Select file
        'dxFileUploader-dropFile': 'Arraste o arquivo aqui', // or Drop file here
        'dxFileUploader-bytes': 'bytes',
        'dxFileUploader-kb': 'kb',
        'dxFileUploader-Mb': 'Mb',
        'dxFileUploader-Gb': 'Gb',
        'dxFileUploader-upload': 'Upload/Carregar', // Upload
        'dxFileUploader-uploaded': 'Uploaded/Carregado', // Uploaded
        'dxFileUploader-readyToUpload': 'Pronto para upload/carregar', // Ready to upload
        'dxFileUploader-uploadFailedMessage': 'Upload/Carregamento falhou', // Upload failed
        'dxRangeSlider-ariaFrom': 'De', // From
        'dxRangeSlider-ariaTill': 'Até', // Till
        'dxSwitch-onText': 'ON',
        'dxSwitch-offText': 'OFF',
        'dxForm-optionalMark': 'opcional', // optional
        'dxForm-requiredMessage': '{0} é requerido', // {0} is required
        'dxNumberBox-invalidValueMessage': 'O Valor precisa ser número', // Value must be a number
        'dxDataGrid-columnChooserTitle': 'Escolha a coluna', // Column Chooser
        'dxDataGrid-columnChooserEmptyText': 'Arraste a coluna aqui para esconder.', // Drag a column here to hide it
        'dxDataGrid-groupContinuesMessage': 'Continue na próxima página', // Continues on the next page
        'dxDataGrid-groupContinuedMessage': 'Continue na página anterior', // Continued from the previous page
        'dxDataGrid-groupHeaderText': 'Agrupe por uma coluna', // Group by This Column
        'dxDataGrid-ungroupHeaderText': 'Desagrupar', // Ungroup
        'dxDataGrid-ungroupAllText': 'Desagrupar Todos', // Ungroup All
        'dxDataGrid-editingEditRow': 'Editar', // Edit
        'dxDataGrid-editingSaveRowChanges': 'Salvar', // Save
        'dxDataGrid-editingCancelRowChanges': 'Cancelar', // Cancel
        'dxDataGrid-editingDeleteRow': 'Excluir', // Delete
        'dxDataGrid-editingUndeleteRow': 'Cancelar Exclusão', // Undelete
        // Are you sure you want to delete this record?,
        'dxDataGrid-editingConfirmDeleteMessage': 'Tem certeza que deseja excluir esse registro?',
        'dxDataGrid-validationCancelChanges': 'Cancelar mudanças', // Cancel changes
        // Drag a column header here to group by that column
        'dxDataGrid-groupPanelEmptyText': 'Arraste uma coluna de cabeçalho aqui para agrupar pela colula',
        'dxDataGrid-noDataText': 'Sem registros', // No data
        'dxDataGrid-searchPanelPlaceholder': 'Pesquisar...', // Search...
        'dxDataGrid-filterRowShowAllText': '(Todos)', // (All)
        'dxDataGrid-filterRowResetOperationText': 'Resetar', // Reset
        'dxDataGrid-filterRowOperationEquals': 'Igual', // Equals
        'dxDataGrid-filterRowOperationNotEquals': 'Não é igual', // Does not equal
        'dxDataGrid-filterRowOperationLess': 'Menor que', // Less than
        'dxDataGrid-filterRowOperationLessOrEquals': 'Menor ou igual a', // Less than or equal to
        'dxDataGrid-filterRowOperationGreater': 'Maior que', // Greater than
        'dxDataGrid-filterRowOperationGreaterOrEquals': 'Maior ou igual a', // Greater than or equal to
        'dxDataGrid-filterRowOperationStartsWith': 'Começa com', // Starts with
        'dxDataGrid-filterRowOperationContains': 'Contém', // Contains
        'dxDataGrid-filterRowOperationNotContains': 'Não contém', // Does not contain
        'dxDataGrid-filterRowOperationEndsWith': 'Termina com', // Ends with
        'dxDataGrid-filterRowOperationBetween': 'Entre', // Between
        'dxDataGrid-filterRowOperationBetweenStartText': 'Início', // Start
        'dxDataGrid-filterRowOperationBetweenEndText': 'Fim', // End
        'dxDataGrid-applyFilterText': 'Aplicar filtros', // Apply filter
        'dxDataGrid-trueText': 'true',
        'dxDataGrid-falseText': 'false',
        'dxDataGrid-sortingAscendingText': 'Ordenar crescente', // Sort Ascending
        'dxDataGrid-sortingDescendingText': 'Ordenar decrescente', // Sort Descending
        'dxDataGrid-sortingClearText': 'Limpar ordem', // Clear Sorting
        'dxDataGrid-editingSaveAllChanges': 'Salvar mudanças', // Save changes
        'dxDataGrid-editingCancelAllChanges': 'Descartar mudanças', // Discard changes
        'dxDataGrid-editingAddRow': 'Adicionar uma linha', // Add a row
        'dxDataGrid-summaryMin': 'Min: {0}',
        'dxDataGrid-summaryMinOtherColumn': 'Min de {1} até {0}', // Min of {1} is {0}
        'dxDataGrid-summaryMax': 'Max: {0}',
        'dxDataGrid-summaryMaxOtherColumn': 'Max de {1} até {0}', // Max of {1} is {0}
        'dxDataGrid-summaryAvg': 'Média: {0}', // Avg: {0}
        'dxDataGrid-summaryAvgOtherColumn': 'Média de {1} até {0}', // Avg of {1} is {0}
        'dxDataGrid-summarySum': 'Soma: {0}', // Sum: {0}
        'dxDataGrid-summarySumOtherColumn': 'Soma de {1} até {0}', // Sum of {1} is {0}
        'dxDataGrid-summaryCount': 'Contagem: {0}', // Count: {0}
        'dxDataGrid-columnFixingFix': 'Fixar', // Fix
        'dxDataGrid-columnFixingUnfix': 'Desafixar', // Unfix
        'dxDataGrid-columnFixingLeftPosition': 'Para a esquerda', // To the left
        'dxDataGrid-columnFixingRightPosition': 'Para a direita', // To the right
        'dxDataGrid-exportTo': 'Exportar', // Export
        'dxDataGrid-exportToExcel': 'Exportar para Excel', // Export to Excel file
        'dxDataGrid-excelFormat': 'Arquivo Excel', // Excel file
        'dxDataGrid-selectedRows': 'Linhas selecionadas', // Selected rows
        'dxDataGrid-exportSelectedRows': 'Exportar linhas selecionadas', // Export selected rows
        'dxDataGrid-exportAll': 'Exportar todos os dados', // Export all data
        'dxDataGrid-headerFilterEmptyValue': '(em Branco)', // (Blanks)
        'dxDataGrid-headerFilterOK': 'OK',
        'dxDataGrid-headerFilterCancel': 'Cancel',
        'dxDataGrid-ariaColumn': 'Coluna', // Column
        'dxDataGrid-ariaValue': 'Valor', // Value
        'dxDataGrid-ariaFilterCell': 'Célula de filtro', // Filter cell
        'dxDataGrid-ariaCollapse': 'Retrair', // Collapse
        'dxDataGrid-ariaExpand': 'Expandir', // Expand
        'dxDataGrid-ariaDataGrid': 'Data grid',
        'dxDataGrid-ariaSearchInGrid': 'Procure nos dados', // Search in data grid
        'dxDataGrid-ariaSelectAll': 'Selecione todos', // Select all
        'dxDataGrid-ariaSelectRow': 'Selecione a linha', // Select row
        'dxTreeList-ariaTreeList': 'Tree list',
        'dxTreeList-editingAddRowToNode': 'Add',
        'dxPager-infoText': 'Page {0} of {1} ({2} items)',
        'dxPager-pagesCountText': 'of',
        'dxPivotGrid-grandTotal': 'Grand Total',
        'dxPivotGrid-total': '{0} Total',
        'dxPivotGrid-fieldChooserTitle': 'Field Chooser',
        'dxPivotGrid-showFieldChooser': 'Show Field Chooser',
        'dxPivotGrid-expandAll': 'Expand All',
        'dxPivotGrid-collapseAll': 'Collapse All',
        'dxPivotGrid-sortColumnBySummary': 'Sort "{0}" by This Column',
        'dxPivotGrid-sortRowBySummary': 'Sort "{0}" by This Row',
        'dxPivotGrid-removeAllSorting': 'Remove All Sorting',
        'dxPivotGrid-dataNotAvailable': 'N/A',
        'dxPivotGrid-rowFields': 'Row Fields',
        'dxPivotGrid-columnFields': 'Column Fields',
        'dxPivotGrid-dataFields': 'Data Fields',
        'dxPivotGrid-filterFields': 'Filter Fields',
        'dxPivotGrid-allFields': 'All Fields',
        'dxPivotGrid-columnFieldArea': 'Drop Column Fields Here',
        'dxPivotGrid-dataFieldArea': 'Drop Data Fields Here',
        'dxPivotGrid-rowFieldArea': 'Drop Row Fields Here',
        'dxPivotGrid-filterFieldArea': 'Drop Filter Fields Here',
        'dxScheduler-editorLabelTitle': 'Subject',
        'dxScheduler-editorLabelStartDate': 'Start Date',
        'dxScheduler-editorLabelEndDate': 'End Date',
        'dxScheduler-editorLabelDescription': 'Description',
        'dxScheduler-editorLabelRecurrence': 'Repeat',
        'dxScheduler-openAppointment': 'Open appointment',
        'dxScheduler-recurrenceNever': 'Never',
        'dxScheduler-recurrenceDaily': 'Daily',
        'dxScheduler-recurrenceWeekly': 'Weekly',
        'dxScheduler-recurrenceMonthly': 'Monthly',
        'dxScheduler-recurrenceYearly': 'Yearly',
        'dxScheduler-recurrenceEvery': 'Every',
        'dxScheduler-recurrenceEnd': 'End repeat',
        'dxScheduler-recurrenceAfter': 'After',
        'dxScheduler-recurrenceOn': 'On',
        'dxScheduler-recurrenceRepeatDaily': 'day(s)',
        'dxScheduler-recurrenceRepeatWeekly': 'week(s)',
        'dxScheduler-recurrenceRepeatMonthly': 'month(s)',
        'dxScheduler-recurrenceRepeatYearly': 'year(s)',
        'dxScheduler-switcherDay': 'Day',
        'dxScheduler-switcherWeek': 'Week',
        'dxScheduler-switcherWorkWeek': 'Work Week',
        'dxScheduler-switcherMonth': 'Month',
        'dxScheduler-switcherAgenda': 'Agenda',
        'dxScheduler-switcherTimelineDay': 'Timeline Day',
        'dxScheduler-switcherTimelineWeek': 'Timeline Week',
        'dxScheduler-switcherTimelineWorkWeek': 'Timeline Work Week',
        'dxScheduler-switcherTimelineMonth': 'Timeline Month',
        'dxScheduler-recurrenceRepeatOnDate': 'on date',
        'dxScheduler-recurrenceRepeatCount': 'occurrence(s)',
        'dxScheduler-allDay': 'All day',
        'dxScheduler-confirmRecurrenceEditMessage': 'Do you want to edit only this appointment or the whole series?',
        'dxScheduler-confirmRecurrenceDeleteMessage': 'Do you want to delete only this appointment or the whole series?',
        'dxScheduler-confirmRecurrenceEditSeries': 'Edit series',
        'dxScheduler-confirmRecurrenceDeleteSeries': 'Delete series',
        'dxScheduler-confirmRecurrenceEditOccurrence': 'Edit appointment',
        'dxScheduler-confirmRecurrenceDeleteOccurrence': 'Delete appointment',
        'dxScheduler-noTimezoneTitle': 'No timezone',
        'dxScheduler-moreAppointments': '{0} more',
        'dxCalendar-todayButtonText': 'Today',
        'dxCalendar-ariaWidgetName': 'Calendar',
        'dxColorView-ariaRed': 'Vermelho', // Vermelho
        'dxColorView-ariaGreen': 'Verde', // Verde
        'dxColorView-ariaBlue': 'Azul', // Azul
        'dxColorView-ariaAlpha': 'Transparência', // Transparency
        'dxColorView-ariaHex': 'Código da Cor', // Color code
        'dxTagBox-selected': '{0} selecionados', // {0} selected
        'dxTagBox-allSelected': 'Todos adicionados ({0})', // All selected ({0})
        'dxTagBox-moreSelected': '{0} mais', // {0} more
        'vizExport-printingButtonText': 'Imprimir', // Print
        'vizExport-titleMenuText': 'Exportando/Imprimindo', // Exporting/Printing
        'vizExport-exportButtonText': '{0} arquivo', // {0} file
        'dxFilterBuilder-and': 'E', // And
        'dxFilterBuilder-or': 'OU', // Or
        'dxFilterBuilder-notAnd': 'Não E', // Not And
        'dxFilterBuilder-notOr': 'Não OU', // Not Or
        'dxFilterBuilder-addCondition': 'Adicione uma Condição', // Add Condition
        'dxFilterBuilder-addGroup': 'Adicione um Grupo', // Add Group
        'dxFilterBuilder-enterValueText': '<digite um valor>', // <enter a value>
        'dxFilterBuilder-filterOperationEquals': 'Igual', // Equals
        'dxFilterBuilder-filterOperationNotEquals': 'Não é igual', // Does not equal
        'dxFilterBuilder-filterOperationLess': 'Menor que', // Less than
        'dxFilterBuilder-filterOperationLessOrEquals': 'Menor ou igual a', // Less than or equal to
        'dxFilterBuilder-filterOperationGreater': 'Maior que', // Greater than
        'dxFilterBuilder-filterOperationGreaterOrEquals': 'Maior ou igual a', // Greater than or equal to
        'dxFilterBuilder-filterOperationStartsWith': 'Começa com', // Starts with
        'dxFilterBuilder-filterOperationContains': 'Contém', // Contains
        'dxFilterBuilder-filterOperationNotContains': 'Não contém', // Does not contain
        'dxFilterBuilder-filterOperationEndsWith': 'Termina com', // Ends with
        'dxFilterBuilder-filterOperationIsBlank': 'É vazio', // Is blank
        'dxFilterBuilder-filterOperationIsNotBlank': 'Não vazio' // Is not blank
    }
};



// WEBPACK FOOTER //
// ./src/app/app.config.ts